import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export interface DialogData {
  header: string;
  text: string;
  properties?: any;
}

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent implements OnInit {
  keys: string[];
  clip: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    if (data.properties) {
      this.keys = typeof data.properties === 'object' ? Object.keys(data.properties).filter(x => !x.endsWith('Id')) : [];
    }
  }

  ngOnInit(): void {}

  formatKey(key: string): string {
    return key.split(/(?=[A-Z])/).join(' ');
  }

  valueForKey(key: string): string {
    let value = this.data.properties[key];
    if (!value) return '';

    let isObject = !!value && typeof value === 'object';

    return isObject ? JSON.stringify(value) : value;
  }

  static open(dialog: MatDialog, data: DialogData) {
    return dialog.open<DialogComponent, DialogData>(DialogComponent, {
      data,
      closeOnNavigation: true,
      hasBackdrop: true,
      minWidth: 340,
    });
  }
}
